export default __webpack_public_path__ + "static/media/oldtavern1.aa077c67.jpg";